// tr strings for messages/studio.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const studio: Dict = {
  "studio.title.none": "Cover yap",
  "studio.title.one": "{name} şarkı söylesin",
  "studio.title.many": "Onlar şarkı söylesin",
  "studio.section.voice": "Ses",
  "studio.section.whoSings": "Kim söylüyor",
  "studio.section.count": "{n} / {max}",
  "studio.section.audio": "Ses dosyası",
  "studio.pickVoice": "Bir ses seç",
  "studio.pickVoiceNote":
    "100.000+ ses arasından seç ya da kendi sesini kullan",
  "studio.addVoice": "Ses ekle",
  "studio.whoSingsWhen": "Kim ne zaman söylüyor",
  "studio.sound": "Ses",
  "studio.video": "Video",
  "studio.video.off": "Seslerini bir Marble Run'da yarıştır",
  "studio.video.on": "Marble Run · 1 jeton",
  "studio.video.add": "Marble Run ekle · 1 jeton",
  "studio.coins.unlimited": "Power ile sınırsız jeton",
  "studio.coins.one": "Kalan jeton: {count}",
  "studio.coins.other": "Kalan jeton: {count}",
  "studio.done": "Tamam",
  "studio.remove": "Kaldır",
  "studio.cta.pickVoice": "Önce bir ses seç",
  "studio.cta.addAudio": "Ses dosyası ekle",
  "studio.cta.create": "Cover oluştur",
  "studio.auth.video": "Video yapmak için kaydol",
  "studio.auth.audio": "Kendi sesini kullanmak için kaydol",
  "studio.auth.save": "Cover'ını kaydet",
  "studio.upgrade.marbleRun":
    "Marble Run videoları yapmak için Creator'a yükselt",
  "studio.creatorReady": "Creator planındasın. Marble Run'ını seç.",
  "studio.maxVoices": "En fazla {max} ses seçebilirsin.",
  "studio.alreadyIn": "{name} zaten bu cover'da.",

  "studio.voices.search": "Ses ara",
  "studio.voices.clear": "Aramayı temizle",
  "studio.voices.trending": "Trend",
  "studio.voices.recent": "Son kullanılanlar",
  "studio.voices.mine": "Seslerim",
  "studio.voices.music": "Müzik",
  "studio.voices.cartoon": "Çizgi film",
  "studio.voices.gaming": "Oyun",
  "studio.voices.anime": "Anime",
  "studio.voices.publicFigure": "Ünlüler",
  "studio.voices.oftenWith": "Sık birlikte: {name}",
  "studio.voices.pairedWith": "Sık eşleştirilen: {name}",
  "studio.voices.add": "Ekle: {name}",
  "studio.voices.change": "Değiştir: {name}",
  "studio.voices.removeName": "Kaldır: {name}",
  "studio.voices.upTo": "En fazla {max}",
  "studio.voices.makeDuet": "Düet yap",
  "studio.voices.uses": "{n} kullanım",
  "studio.voices.noMatch": "Bu aramayla eşleşen ses yok.",
  "studio.voices.noMine": "Henüz eğittiğin bir ses yok.",
  "studio.voices.noPairs":
    "Bu hafta bu sesle henüz düet yapılmadı. Trend'e göz at.",
  "studio.empty": "Burada henüz bir şey yok.",
  "studio.change": "Değiştir",

  "studio.who.auto": "Otomatik seç",
  "studio.who.manual": "Kendim seçeyim",
  "studio.who.chose.one": "Sen seçtin · {n} bölüm",
  "studio.who.chose.other": "Sen seçtin · {n} bölüm",
  "studio.who.autoExplain":
    "Şarkıda söyleyen her değiştiğinde sesler sırayla devreye girer.",
  "studio.who.autoCanChoose":
    "Sen mi karar vermek istiyorsun? Kendim seçeyim ile her bölümü kimin söyleyeceğini seçebilirsin.",
  "studio.who.autoNeedsFile":
    "Kendin seçmek için bir yükleme, kayıt ya da kütüphaneden bir şarkı gerekir.",
  "studio.who.loading": "Şarkı yükleniyor…",
  "studio.who.failed":
    "Bu şarkıyı burada çalamadık, bu yüzden kararı Jammable verecek.",
  "studio.who.pause": "Duraklat",
  "studio.who.playSong": "Şarkıyı çal",
  "studio.who.partLabel": "{name}, {start} - {end}",
  "studio.who.moveSwap": "Seslerin değiştiği yeri taşı",
  "studio.who.part": "Bölüm {n}",
  "studio.who.play": "Çal",
  "studio.who.split": "Böl",
  "studio.who.takeOver": "Bu bölümü kim devralsın?",
  "studio.who.before": "Önceki bölüm",
  "studio.who.after": "Sonraki bölüm",
  "studio.who.sungBy": "Söyleyen",
  "studio.who.hint":
    "Dinlemek ve kimin söyleyeceğini seçmek için bir bölüme dokun. Seslerin değiştiği yeri taşımak için beyaz tutamaçları sürükle.",
  "studio.who.tooShort": "Her bölüm en az {secs} saniye olmalı.",

  "studio.song.upload": "Yükle",
  "studio.song.library": "Kütüphane",
  "studio.song.tts": "Metin yaz",
  "studio.song.generate": "AI şarkı",
  "studio.song.mic": "Kaydet",
  "studio.song.sources": "Şarkının kaynağı",
  "studio.song.rights":
    "Yalnızca kullanım hakkına sahip olduğun sesleri yükle.",
  "studio.song.search": "Şarkı ara",
  "studio.song.searchUploads": "Yüklemelerinde ara",
  "studio.song.searchLibrary": "Şarkı kütüphanesinde ara",
  "studio.song.popular": "Popüler",
  "studio.song.yourUploads": "Yüklemelerin",
  "studio.song.noMatch": "Bu aramayla eşleşen şarkı yok.",
  "studio.song.noUploads": "Henüz bir şey yüklemedin.",
  "studio.song.picked": "Seçildi",
  "studio.source.generate": "AI ile üretildi",
  "studio.source.upload": "Yüklendi",
  "studio.source.library": "Kütüphaneden",
  "studio.source.mic": "Kaydedildi",
  "studio.source.tts": "Metinden sese",

  "studio.tts.what": "Ne söylesinler?",
  "studio.tts.placeholder": "Ne söylemelerini istediğini yaz...",
  "studio.tts.baseVoice": "TEMEL SES",
  "studio.tts.accent": "AKSAN",
  "studio.tts.delivery": "TON",
  "studio.tts.use": "Bu metni kullan",
  "studio.tts.empty": "Lütfen bir metin gir.",
  "studio.tts.tooLong": "Metin en fazla {max} karakter olabilir.",
  "studio.tts.gender.female": "Kadın",
  "studio.tts.gender.male": "Erkek",
  "studio.tts.accent.US": "Amerikan",
  "studio.tts.accent.GB": "İngiliz",
  "studio.tts.accent.FR": "Fransız",
  "studio.tts.accent.DE": "Alman",
  "studio.tts.accent.ES": "İspanyol",
  "studio.tts.accent.IT": "İtalyan",
  "studio.tts.accent.KR": "Koreli",
  "studio.tts.accent.AU": "Avustralyalı",
  "studio.tts.accent.JP": "Japon",
  "studio.tts.expr.default": "Normal",
  "studio.tts.expr.whispered": "Fısıltı",
  "studio.tts.expr.happy": "Mutlu",
  "studio.tts.expr.sad": "Üzgün",
  "studio.tts.expr.angry": "Kızgın",
  "studio.tts.expr.shouting": "Bağırarak",
  "studio.tts.expr.terrified": "Dehşet içinde",

  "studio.ai.style": "BİR TARZ SEÇ YA DA TARİF ET",
  "studio.ai.styleLabel": "Şarkı tarzı",
  "studio.ai.stylePlaceholder":
    "ör. enerjik yaz popu, akustik gitar, akılda kalan nakarat",
  "studio.ai.lyrics": "Şarkı sözleri",
  "studio.ai.lyricsPlaceholder":
    "Sözleri yapay zekanın yazması için boş bırak ya da:\n\n[Verse 1]\nSözlerini buraya yaz...\n\n[Chorus]\nYapı vermek için [Verse], [Chorus], [Bridge] etiketlerini kullan",
  "studio.ai.ownLyrics": "+ Kendi sözlerini yaz (yazmazsan yapay zeka yazar)",
  "studio.ai.use": "Bu şarkıyı kullan",
  "studio.ai.noStyle": "Şarkının tarzını tarif et.",
  "studio.ai.styleTooLong": "Tarz açıklaması {max} karakterden kısa olmalı.",
  "studio.ai.lyricsTooLong": "Şarkı sözleri {max} karakterden kısa olmalı.",
  "studio.ai.genre.pop": "Pop",
  "studio.ai.genre.trap": "Trap",
  "studio.ai.genre.rnb": "R&B",
  "studio.ai.genre.indie": "Indie",
  "studio.ai.genre.kpop": "K-pop",
  "studio.ai.genre.edm": "EDM",
  "studio.ai.genre.lofi": "Lo-fi",
  "studio.ai.genre.country": "Country",
  "studio.seo.title": "Cover oluştur | Jammable",
  "studio.seo.description":
    "Bir ses seç, kullanım hakkına sahip olduğun bir ses dosyası ekle ve Jammable'da AI cover yap.",
};

export default studio;
